<div class="container-fluid login-page">
  <form class="auth-wrapper" [formGroup]="authForm" (ngSubmit)="onSubmit()">

  <!-- STEP 1 -->
  <ng-container *ngIf="step === 1">
    <div class="login-layout">
      <section class="promo-panel">
        <img class="promo-logo" src="assets/img/logo.png" alt="livepass" />

        <div class="promo-copy">
          <h1>List and manage<br />your events<br /><span>the simple way</span></h1>
          <p>Everything you need to create, manage and grow your events &mdash; all in one place.</p>
        </div>

        <div class="feature-list">
          <div class="feature-item">
            <div class="feature-icon ticket-icon"></div>
            <div>
              <h3>Create &amp; publish events</h3>
              <p>Create your event in minutes and publish it to reach more people.</p>
            </div>
          </div>

          <div class="feature-item">
            <div class="feature-icon attendee-icon"></div>
            <div>
              <h3>Manage attendees</h3>
              <p>Track registrations, check-ins and engage with your audience.</p>
            </div>
          </div>

          <div class="feature-item">
            <div class="feature-icon chart-icon"></div>
            <div>
              <h3>Track performance</h3>
              <p>Get real-time insights on sales, attendees and event performance.</p>
            </div>
          </div>
        </div>
      </section>

      <div class="auth-card">
        <div class="text-center card-logo">
          <img src="assets/img/logo.png" alt="livepass" />
        </div>
        <h2 class="title">List your events</h2>

        <p class="subtitle">
          Verify your email to create your organiser profile and start selling tickets.
        </p>

        <!-- SOCIAL LOGIN -->
        <button type="button" class="btn social google"> 
          <img src="https://www.svgrepo.com/show/475656/google-color.svg" alt="" />
          Continue with Google
        </button>

        <!-- <button type="button" class="btn social google" (click)="loginWithGoogle()" [disabled]="loading">
          <img src="https://www.svgrepo.com/show/475656/google-color.svg" />
          Continue with Google
        </button> -->

        <!-- <button type="button" class="btn social apple">
          <img src="https://www.svgrepo.com/show/511330/apple-173.svg" />
          Continue with Apple
        </button> -->

        <div class="divider"><span>or</span></div>

        <!-- EMAIL -->
        <label class="label">Email address</label>
        <div class="input-wrap">
          <span class="email-icon"></span>
          <input type="email" class="input" placeholder="Enter your email" formControlName="email" />
        </div>

        <small class="error" *ngIf="(email?.touched || submitted) && email?.invalid">
          Enter a valid email address
        </small>

        <!-- ACCOUNT TYPE -->
        <label class="label">Registering as</label>
        <div class="registering-as">
          <div class="type-wrap">

            <div class="type-card" [class.active]="authForm.get('accounttype')?.value === 'individual'"
              (click)="selectType('individual')">

              <img class="type-icon" src="assets/img/indivisual.png" alt="" />
              <div class="content">
                <h4>Individual</h4>
                <p>For personal events and individual organisers</p>
              </div>

              <div class="content_radio">
                <div class="radio"><span></span></div>
              </div>
            </div>

            <div class="type-card" [class.active]="authForm.get('accounttype')?.value === 'organiser'"
              (click)="selectType('organiser')">

              <img class="type-icon" src="assets/img/organisation.png" alt="" />
              <div class="content">
                <h4>Organisation</h4>
                <p>For companies, clubs, and business events</p>
              </div>

              <div class="content_radio">
                <div class="radio"><span></span></div>
              </div>
            </div>

          </div>
        </div>

        <small class="error"
          *ngIf="(authForm.get('accounttype')?.touched || submitted) && authForm.get('accounttype')?.invalid">
          Please select account type
        </small>

        <button type="submit" class="primary-btn send_otp" [disabled]="loading">
          {{ loading ? 'Sending OTP...' : 'Send OTP' }}
        </button>

        <span class="continue"> By continuing, you agree to our <a routerLink="/terms-and-conditions">Terms of Service</a> and <a routerLink="/privacy-policy">Privacy Policy</a> </span>
      </div>
    </div>
  </ng-container>

  <!-- STEP 2 -->
  <ng-container *ngIf="step === 2">
    <div class="verify-wrapper">
      <div class="card">

        <a class="back-link" (click)="goBack()">← Back</a>

        <h2>Verify your email</h2>
        <p class="subtitle">
          We've sent a verification code to <br />
          <strong>{{ email?.value }}</strong>
        </p>

        <label class="otp-label">Enter verification code</label>

        <div class="otp-inputs">
          <input *ngFor="let ctrl of otpControls; let i = index" type="text" inputmode="numeric" maxlength="1"
            class="otp-box" [formControl]="ctrl" (input)="onOtpInput($event, i)" (keydown)="onKeyDown($event, i)"
            (paste)="onPaste($event)" />
        </div>

        <small class="error mt-0" *ngIf="otpInvalid">Invalid OTP</small>

        <button type="button" class="verify-btn" [disabled]="!isOtpComplete() || loading" (click)="verifyOtp()">
          {{ loading ? 'Verifying...' : 'Verify & Continue' }}
        </button>

        <p class="resend-text">Didn't receive the code?</p>

        <a class="resend-link" *ngIf="canResend" (click)="resendOtp()">
          Resend OTP
        </a>

        <p class="timer" *ngIf="!canResend">
          Code expires in {{ timer }}
        </p>

      </div>
    </div>
  </ng-container>

  <!-- STEP 3: SUCCESS -->
  <ng-container *ngIf="step === 3">
    <div class="verify-wrapper">
      <div class="card success-card">

        <div class="success-icon">
          ✓
        </div>

        <h2>Email Verified!</h2>
        <p class="subtitle">
          Your email has been successfully verified. <span *ngIf="organizerOld == false">Let's complete your profile.</span>
        </p>

        <button class="verify-btn success-btn" (click)="continueToProfile()">
          Continue to Profile
        </button>

      </div>
    </div>
  </ng-container>

</form>
</div>